import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Google
 * id F3E26F6E-9F9A-490B-A28A-1BD32A60D143
 * name playlist-check
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/playlist-check.svg
 * tags
 */
export const PlaylistCheckIcon = createSvgIcon(<><path d="M14 10H3V12H14V10M14 6H3V8H14V6M3 16H10V14H3V16M21.5 11.5L23 13L16 20L11.5 15.5L13 14L16 17L21.5 11.5Z" /></>, 'PlaylistCheckIcon');
export default PlaylistCheckIcon